import { render, staticRenderFns } from "./JsonViewDialog.vue?vue&type=template&id=745a21fa"
import script from "./JsonViewDialog.vue?vue&type=script&lang=js"
export * from "./JsonViewDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports